<template>
    <BannerBlue title="catálogos" />
    <div class="container">
        <div class="contenedor-externo">
            <div style="width: 90%; display: flex; justify-content: end;">
                <span style="margin-right: 5px;">Filtro</span>
                <Dropdown v-model="categoriafiltro" inputId="dd-city" :options="catnames" optionLabel="name"
                    style="width: 200px; border: 1px solid gray; padding: 5px;" @change="changeFilter()" />
            </div>
            <div v-for="(imagen, index) in catalogos" :key="index" class="contenedor-interno">
                <div class="title-cat mb-1">
                    <a class="img-cat" target="_blank">
                        <h4 style="bottom:5px;">{{ imagen.name_catalogos }}</h4>
                    </a>
                </div>
                <a class="img-cat" id="show-button" target="_blank" @click="verModal(imagen.pdf_catalogos)"
                    style="cursor: pointer;">
                    <img loading="lazy" :src="imagen.image_catalogos" :alt="imagen.name_catalogos" />
                </a>
            </div>
        </div>
    </div>
    <div>
        <div v-if="isDialogOpen" class="backdrop" @click="closeDialog()">
            <div class="dialog" @click.stop>
                <button class="close-btn" @click="closeDialog()">✖</button>

                <embed :src="urlpdf" type="application/pdf" width="100%" height="100%" style="padding: 26px;" />
            </div>
        </div>
    </div>
</template>

<script>

import BannerBlue from '@/components/BannerBlue.vue';
import { ApiService } from '@/services/ApiService';
import { ref } from 'vue';
export default {
    props: {},
    components: {
        BannerBlue,
    },
    data() {
        return {
            layout: ref('grid'),
            catalogosOrdenados: ref([]),
            isDialogOpen: false,
            urlpdf: "",
            categoriafiltro: { name: 'TODOS', code: "todo" },
            catnames: [
                { name: 'TODOS', code: "todo" },
                { name: 'AUTOMOTRIZ', code: "automotriz" },
                { name: 'SEGURIDAD', code: "seguridad" },
                { name: 'SOLDADOR', code: "soldador" },
                { name: 'CANDADOS', code: "candados" },
                { name: 'CERRADURA', code: "cerradura" },
                { name: 'ACCESORIOS', code: "accesorios" },
                { name: 'HERRAMIENTAS', code: "herramientas" },
                { name: 'ABRASIVOS', code: "abrasivos" },
                { name: 'SIERRAS', code: "sierras" },
                { name: 'ELECTRICA', code: "electrica" },
                { name: 'PINTURA', code: "pintura" },
                { name: 'PLOMERIA', code: "plomeria" },
                { name: 'TORNILLERIA', code: "tornilleria" },
            ],
            catalogos: [],
            catalogosOld: [
                {
                    id_catalogos: 1,
                    name_catalogos: "abus motorbike",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/abus-motorbike-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/abus-motorbike-2025.webp",
                    categories_catalogos: "['todo','automotriz','accesorios', 'candados']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 2,
                    name_catalogos: "ati tools",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/atitools-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/atitools-2025.webp",
                    categories_catalogos: "['todo','herramientas','sierras']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 3,
                    name_catalogos: "austromex",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/austromex-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/austromex-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'abrasivos', ]",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 4,
                    name_catalogos: "axtech",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/axtech-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/axtech-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'electrica', 'soldador']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 5,
                    name_catalogos: "bahco",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/bahco-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/bahco-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'accesorios']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 6,
                    name_catalogos: "bahco sierras",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/bahco-sierras-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/bahco-sierras-2025.webp",
                    categories_catalogos: "['todo', 'sierras', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 7,
                    name_catalogos: "bgs",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/bgs-2024.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/bgs-2024.webp",
                    categories_catalogos: "['todo', 'herramientas', 'automotriz', 'accesorios']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 8,
                    name_catalogos: "blue point",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/bluepoint-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/bluepoint-2025.webp",
                    categories_catalogos: "['todo', 'automotriz', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 9,
                    name_catalogos: "bosch h. eléctrica",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/bosch-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/bosch-2025.webp",
                    categories_catalogos: "['todo', 'herramienta', 'accesorios', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 10,
                    name_catalogos: "bosch accesorios",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/bosch-accesorios-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/bosch-accesorios-2025.webp",
                    categories_catalogos: "['todo', 'herramienta', 'accesorios', 'abrasivos']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 11,
                    name_catalogos: "bosch soluciones metales",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/bosch-soluciones-metales-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/bosch-soluciones-metales-2025.webp",
                    categories_catalogos: "['todo', 'herramienta', 'accesorios', 'abrasivos']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 12,
                    name_catalogos: "byp",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/byp-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/byp-2025.webp",
                    categories_catalogos: "['todo', 'herramienta', 'pintura']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 13,
                    name_catalogos: "cleveland",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/cleveland-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/cleveland-2025.webp",
                    categories_catalogos: "['todo', 'herramienta', 'accesorios', 'abrasivos']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 14,
                    name_catalogos: "dewalt",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/dewalt-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/dewalt-2025.webp",
                    categories_catalogos: "['todo', 'herramienta', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 15,
                    name_catalogos: "dexter",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/dexter-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/dexter-2025.webp",
                    categories_catalogos: "['todo', 'cerradura', 'herramienta', 'candados']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 16,
                    name_catalogos: "dica",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/dica-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/dica-2025.webp",
                    categories_catalogos: "['todo', 'plomeria', 'accesorios']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 17,
                    name_catalogos: "evans",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/evans-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/evans-2025.webp",
                    categories_catalogos: "['todo', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 18,
                    name_catalogos: "fandeli",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/fandeli-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/fandeli-2025.webp",
                    categories_catalogos: "['todo', 'accesorios', 'abrasivos']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 19,
                    name_catalogos: "force tools",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/forcetools-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/forcetools-2025.webp",
                    categories_catalogos: "['todo', 'herramienta', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 20,
                    name_catalogos: "freud",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/freud-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/freud-2025.webp",
                    categories_catalogos: "['todo', 'herramienta', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 21,
                    name_catalogos: "handy home",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/handyhome-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/handyhome-2025.webp",
                    categories_catalogos: "['todo', 'accesorios', 'cerrajeria']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 22,
                    name_catalogos: "herralum",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/herralum-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/herralum-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'accesorios', 'cerradura']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 23,
                    name_catalogos: "index",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/index-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/index-2025.webp",
                    categories_catalogos: "['todo', 'tornilleria']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 24,
                    name_catalogos: "iusa",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/iusa-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/iusa-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'accesorios', 'electrica', 'seguridad']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 25,
                    name_catalogos: "karcher",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/karcher-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/karcher-2025.webp",
                    categories_catalogos: "['todo', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 26,
                    name_catalogos: "karcher tradicional",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/karcher-tradicional-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/karcher-tradicional-2025.webp",
                    categories_catalogos: "['todo', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 27,
                    name_catalogos: "klein tools construccion",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-construccion-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-construccion-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 28,
                    name_catalogos: "klein tools contratistas",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-contratistas-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-contratistas-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 29,
                    name_catalogos: "klein tools epp",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-epp-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-epp-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 30,
                    name_catalogos: "klein tools forjado",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-forjado-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-forjado-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 31,
                    name_catalogos: "klein tools hvacr",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-hvacr-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-hvacr-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 32,
                    name_catalogos: "klein tools industrial",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-industrial-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-industrial-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 33,
                    name_catalogos: "klein tools mangos de traccion",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-mangostraccion-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-mangostraccion-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 34,
                    name_catalogos: "klein tools nuevos productos",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-nuevosproductos-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-nuevosproductos-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 35,
                    name_catalogos: "klein tools p. y m.",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-pym-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-pym-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 36,
                    name_catalogos: "klein tools serv. eléctrico",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-servicioelectrico-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-servicioelectrico-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 37,
                    name_catalogos: "klein tools telecom.",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kleintools-telecomunicaciones-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kleintools-telecomunicaciones-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 38,
                    name_catalogos: "knipex electrica",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/knipex-electrica-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/knipex-electrica-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 39,
                    name_catalogos: "knipex general",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/knipex-general-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/knipex-general-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 40,
                    name_catalogos: "knipex pliers",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/knipex-pliers-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/knipex-pliers-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 41,
                    name_catalogos: "kps",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/kps-2023.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/kps-2023.webp",
                    categories_catalogos: "['todo', 'herramientas', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 42,
                    name_catalogos: "libus",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/libus-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/libus-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'seguridad']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 43,
                    name_catalogos: "lincoln",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/lincoln-2024.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/lincoln-2024.webp",
                    categories_catalogos: "['todo', 'herramientas', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 44,
                    name_catalogos: "lock",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/lock-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/lock-2025.webp",
                    categories_catalogos: "['todo', 'candados', 'cerrajeria']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 45,
                    name_catalogos: "loctite",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/loctite-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/loctite-2025.webp",
                    categories_catalogos: "['todo', 'accesorios']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 46,
                    name_catalogos: "makita general",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/makita-general-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/makita-general-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 47,
                    name_catalogos: "mikels",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/mikels-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/mikels-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'automotriz', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 48,
                    name_catalogos: "milwaukee accesorios",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/milwaukee-accesorios-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/milwaukee-accesorios-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'accesorios']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 49,
                    name_catalogos: "milwaukee epp",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/milwaukee-epp-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/milwaukee-epp-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'seguridad']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 50,
                    name_catalogos: "milwaukee general",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/milwaukee-general-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/milwaukee-general-2025.webp",
                    categories_catalogos: "['todo','herramientas', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 51,
                    name_catalogos: "safefit",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/safefit-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/safefit-2025.webp",
                    categories_catalogos: "['todo', 'seguridad']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 52,
                    name_catalogos: "sika",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/sika-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/sika-2025.webp",
                    categories_catalogos: "['todo', 'accesorios']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 53,
                    name_catalogos: "sioux",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/sioux-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/sioux-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 54,
                    name_catalogos: "snapon industrial",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/snapon-industrial-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/snapon-industrial-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'automotriz']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 55,
                    name_catalogos: "snapon industrial",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/snapon-industrial-all-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/snapon-industrial-all-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'automotriz']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 57,
                    name_catalogos: "stanley h. eléctrica",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/stanley-herramientaelectrica-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/stanley-herramientaelectrica-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 58,
                    name_catalogos: "stanley v20",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/stanley-v20-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/stanley-v20-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'electrica']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 59,
                    name_catalogos: "synergy",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/synergy-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/synergy-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'electrica', 'soldador']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 60,
                    name_catalogos: "tecnolite",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/tecnolite-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/tecnolite-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'accesorios']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 61,
                    name_catalogos: "tonka",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/tonka-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/tonka-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 62,
                    name_catalogos: "truper",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/truper-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/truper-2025.webp",
                    categories_catalogos: "['todo','herramientas', 'seguridad', 'electrica', 'sierras', 'abrasivos']",
                    import_catalogos: 4
                },
                {
                    id_catalogos: 63,
                    name_catalogos: "tuk",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/tuk-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/tuk-2025.webp",
                    categories_catalogos: "['todo', 'accesorios']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 64,
                    name_catalogos: "tulmex",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/tulmex-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/tulmex-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 65,
                    name_catalogos: "urrea plomeria",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/urrea-plomeria-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/urrea-plomeria-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'plomeria', 'accesorios']",
                    import_catalogos: 3
                },
                {
                    id_catalogos: 66,
                    name_catalogos: "urrea valvulas",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/urrea-valvulas-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/urrea-valvulas-2025.webp",
                    categories_catalogos: "['todo', 'herramientas', 'plomeria']",
                    import_catalogos: 2
                },
                {
                    id_catalogos: 67,
                    name_catalogos: "urrea",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/urrea-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/urrea-2025.webp",
                    categories_catalogos: "['todo','herramientas', 'seguridad', 'electrica', 'sierras', 'abrasivos']",
                    import_catalogos: 1
                },
                {
                    id_catalogos: 68,
                    name_catalogos: "weston",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/weston-2024.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/weston-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 69,
                    name_catalogos: "william",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/william-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/william-2025.webp",
                    categories_catalogos: "['todo', 'herramientas']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 70,
                    name_catalogos: "abus",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/abus-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/abus-2025.webp",
                    categories_catalogos: "['todo','accesorios', 'candados']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 71,
                    name_catalogos: "jyrsa",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/jyrsa-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/jyrsa-2025.webp",
                    categories_catalogos: "['todo','accesorios', 'seguridad']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 72,
                    name_catalogos: "lica",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/lica-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/lica-2025.webp",
                    categories_catalogos: "['todo','accesorios', 'seguridad']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 74,
                    name_catalogos: "proto",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/proto-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/proto-2025.webp",
                    categories_catalogos: "['todo','accesorios', 'automotriz', 'herramienta']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 75,
                    name_catalogos: "veker",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/veker-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/veker-2025.webp",
                    categories_catalogos: "['todo','accesorios', 'herramienta']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 76,
                    name_catalogos: "wd-40",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/wd40-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/wd40-2025.webp",
                    categories_catalogos: "['todo','accesorios', 'herramienta']",
                    import_catalogos: 10
                },
                {
                    id_catalogos: 77,
                    name_catalogos: "nitro",
                    pdf_catalogos: "https://files.proveedorferretero.net/pdf/2025/catalogos/nitro-2025.pdf",
                    date_catalogos: 2025,
                    image_catalogos: "https://files.proveedorferretero.net/img/2025/catalogo/nitro-2025.webp",
                    categories_catalogos: "['todo','accesorios', 'herramienta']",
                    import_catalogos: 10
                },
            ],
        };
    },
    mounted: function () {
        this.getData();

    },
    async beforeMount() {
        console.log(this.$route.params.filtercat);

        //infoProduct.getAllDataProduct().then((data) => (this.infoP = data));
        //ApiService.get("/product", this.vproduct).then((data) => (this.infoP = data));//Ya está el llamado a la API
        if (this.$route.params.filtercat != undefined) {
            let posicion = this.catnames.findIndex(item => item.code === (this.$route.params.filtercat).toLowerCase());
            if (posicion !== -1) {
                this.categoriafiltro = this.catnames[posicion]
            } else {
                this.categoriafiltro = { name: 'TODOS', code: "todo" }
                // Cambiar el parámetro en la URL sin recargar la página
                this.$router.push({ name: 'catalogos', params: { filtercat: this.categoriafiltro.code } });
            }
        } else {
            this.categoriafiltro = { name: 'TODOS', code: "todo" }
            // Cambiar el parámetro en la URL sin recargar la página
            this.$router.push({ name: 'catalogos', params: { filtercat: this.categoriafiltro.code } });
        }
    },
    watch: {
        '$route.params.filtercat'(newFilter) {
            if (newFilter != undefined) {
                console.log(newFilter);

                let posicion = this.catnames.findIndex(item => item.code === newFilter.toLowerCase());
                if (posicion !== -1) {
                    this.categoriafiltro = this.catnames[posicion];
                    this.getData();
                } else {
                    this.categoriafiltro = { name: 'TODOS', code: "todo" }
                    this.getData();
                }
            }

        },
    },
    methods: {
        async getData() {
            this.catalogos.splice(0, this.catalogos.length);
            for (let i = 0; i < this.catalogosOld.length; i++) {
                if (this.catalogosOld[i].categories_catalogos.includes(this.categoriafiltro.code)) {
                    this.catalogos.push(this.catalogosOld[i])
                }
            }
            this.ordenarCatalogos();
            /*
            await ApiService.get('/catalogosfilter?categoriafiltro='+ this.categoriafiltro.code)//Llamamos al Service de las apis para traer datos en get
                        .then(async data => {
                            this.catalogos = data;
                            
                            this.ordenarCatalogos();
                        })
                        .catch(error => {
                            console.error('Error en la solicitud:', error.message);
                        });
            */
        },
        async changeFilter() {
            this.$router.push({ name: 'catalogos', params: { filtercat: this.categoriafiltro.code } });
            this.getData();
        },
        ordenarCatalogos() {
            // Ordenar primero por "imp" y luego por "title"
            this.catalogos.sort((a, b) => {
                if (a.import_catalogos !== b.import_catalogos) {
                    return a.import_catalogos - b.import_catalogos;
                } else {
                    return a.name_catalogos.localeCompare(b.name_catalogos);
                }
            });
        },
        verModal(pdf) {
            this.isDialogOpen = true;
            this.urlpdf = pdf;
        },
        closeDialog() {
            this.isDialogOpen = false;
            this.urlpdf = "";
        }
    },
}
</script>

<style scoped>
/* Fondo semitransparente */
.backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999999;
}

/* Contenedor del diálogo */
.dialog {
    background: white;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    position: relative;
    width: 80%;
    height: 95%;
}

@media only screen and (max-width: 600px) {
    .dialog {
        background: white;
        padding: 10px;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        position: relative;
        width: 100%;
        height: 100%;
    }
}

/* Botón de cerrar */
.close-btn {
    position: absolute;
    top: 1px;
    right: 1px;
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
}

h4 {
    line-height: 40px;
}

h4:hover {
    color: #ffbf00;
}

img:hover {
    box-shadow: 0 0 20px #ffbf00;
}

.contenedor-externo {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.contenedor-interno {
    margin-right: 10px;
    /* Espacio entre los contenedores internos, ajusta según tu preferencia */
    max-width: 400px;
}

.title-cat {
    height: 80px;
    display: flex;
    text-align: start;
    align-items: flex-end;
}

.title-cat a h3 {
    color: #000;
}

.title-cat img {
    box-shadow: none;
}

.contenedor-interno a img:hover~.title-cat a h3 {
    color: #ffbf00;
}

.title-cat a h3:hover {
    color: #ffbf00;
}

img {
    width: 100%;
    /* Asegura que las imágenes ocupen todo el ancho del contenedor interno */
    height: auto;
    /* Permite que la altura se ajuste proporcionalmente al ancho */
    border-radius: 10px;
}

@media (max-width: 1200px) {
    .img {
        width: 80%;
    }

    .title-cat {
        padding-left: 15px;
    }
}
</style>